import React from 'react'
import * as UI from 'ui'
import { SubmitButton } from 'ui'
import { WhenIsPiping } from '@morningtrain/react-pipelines'
import { Translation } from '@morningtrain/react-translations'
import { LoadingSpinner } from 'ui/animations'
import FiredAtBadge from 'pages/app/users/partials/FiredAtBadge'

export default function StopEmploymentCancellationButton () {
  return (
          <div className="form-element">
            <FiredAtBadge/>
            <div className="mt-6"></div>
            <SubmitButton color="red">
              <UI.Text className="flex space-x-3 items-center" block>
                <p>
                  <Translation name="actions.stop_employment_cancellation"/>
                </p>
                <WhenIsPiping>
                  <LoadingSpinner color="white"/>
                </WhenIsPiping>
              </UI.Text>
            </SubmitButton>
          </div>
  )
}
